module.exports = __webpack_public_path__ + "media/images/area/area_ehimeM400-e9eded772a16f9eb06f39fae267e2b99.jpg";